import { render, staticRenderFns } from "./WSMenu.vue?vue&type=template&id=52518999&"
import script from "./WSMenu.vue?vue&type=script&lang=js&"
export * from "./WSMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports